import { Component, OnInit } from '@angular/core';
import { AuthorizationPolicy } from '@microsoft/microsoft-graph-types-beta';
import { BaseComponent } from '../../base/base.component';
import {
    generateUserConsentPolicySchema,
    getUserConsentPolicyDesiredValue,
} from '../../../../../tools/schemas/graph/user-consent-policy.schema';

@Component({
    selector: 'app-baseline',
    templateUrl: './baseline.component.html',
    styleUrls: ['./baseline.component.scss', '../../styles/baseline-style.scss'],
})
export class BaselineComponent extends BaseComponent implements OnInit {
    data: AuthorizationPolicy;

    ngOnInit(): void {
        const desiredValue =
            this.baseline.schema.properties['permissionGrantPolicyIdsAssignedToDefaultUserRole'].items.enum;

        this.control.setValue(getUserConsentPolicyDesiredValue(desiredValue));

        this.control.valueChanges.subscribe((value) => {
            const schema = generateUserConsentPolicySchema(value);

            this.baselineChange.next({
                ...this.baseline,
                schema: JSON.parse(JSON.stringify(schema)),
            });
        });
    }

    getValue(permissionGrantPolicyIdsAssignedToDefaultUserRole: string[]): { value: string; hint: string } {
        if (
            permissionGrantPolicyIdsAssignedToDefaultUserRole.includes(
                'ManagePermissionGrantsForSelf.microsoft-user-default-low',
            )
        ) {
            return {
                value: 'Allow user consent for apps from verified publishers, for selected permissions (Recommended)',
                hint: 'All users can consent for permissions classified as "low impact", for apps from verified publishers or apps registered in this organization.',
            };
        } else if (
            permissionGrantPolicyIdsAssignedToDefaultUserRole.includes(
                'ManagePermissionGrantsForSelf.microsoft-user-default-legacy',
            )
        ) {
            return {
                value: 'Allow user consent for apps',
                hint: `All users can consent for any app to access the organization's data.`,
            };
        } else {
            return {
                value: 'Do not allow user consent',
                hint: 'An administrator will be required for all apps.',
            };
        }
    }
}
